<template>
  <div
    class="otp-container"
    v-if="show">
    <weex-text class="item-bold-heading margin-top-10">Enter the OTP</weex-text>

    <div
      v-if="logo"
      style="width: 200px"
      class="item-align-right item-row-alignment-baseline margin-top-10">
      <weex-text class="font-weight-bold font-size-sm-base margin-right-5">Powered By</weex-text>

      <weex-image
        :src="logo"
        style="width: 108px; height: 30px"
        ></weex-image>
    </div>

    <weex-text
      class="font-size-sm margin_top_20"
      v-if="lenderOtpMessage"
      v-html="lenderOtpMessage"
      ></weex-text>

    <div class="margin_top_20">
      <weex-text class="input_label">OTP</weex-text>
      <input
        class="input_with_border_bottom"
        :value="otp"
        @input="onOTPUpdated($event.target.value)"
        type="number"
        return-key-type="next"
        />
    </div>

    <div class="margin-top-10">
      <weex-text>
        <span class="font-size-sm text-color-blue">Did not receive OTP?</span>
        <span
          v-if="!countdownCompleted"
          class="font-size-sm text-color-blue">&nbsp;Resend OTP in
        </span>
        <span
          v-if="!countdownCompleted"
          class="font-size-sm text-color-blue">{{countdownRemainingSeconds}} second(s).
        </span>
        <span
          @click="resendOtp"
          v-if="countdownCompleted"
          class="item-sm-link">Click here
        </span>
        <span
          v-if="countdownCompleted"
          class="font-size-sm text-color-blue">to resend OTP.
        </span>
      </weex-text>
      <wxc-countdown
        v-if="!countdownCompleted"
        v-show="false"
        tpl="{s}"
        :time="countDowntime"
        @wxcOnComplete="onCountdownCompleted"
        @countdownDetails="countdownDetails"
        ></wxc-countdown>
    </div>

    <wxc-button
      class="margin_top_20 horizontal_center"
      type="blue"
      text="Submit OTP"
      @wxcButtonClicked="onSubmitOtp"
      ></wxc-button>

    <weex-text
      v-if="error"
      class="font-size-sm-base text-color-red"
      v-html="error"
      ></weex-text>
  </div>
</template>
<script>

  import WxcButton from "../../../weex-ui/packages/wxc-button/index"
  import EzUtils from "../../utils/EzUtils";
  import WxcCountdown from "../../../weex-ui/packages/wxc-countdown/index";

  const RESEND_OTP_TIME = 30 * 1000; // 30 secs

  export default {
    name: "LenderOtpView",
    components: { WxcButton, WxcCountdown },
    data: () => ({
      otp: "",
      countdownCompleted: false,
      countdownRemainingSeconds: "",
      countDowntime: "",
      validationError: ""
    }),

    props: {
      logo: {
        type: String,
        default: ""
      },
      otpError: {
        type: String,
        default: ""
      },
      lenderOtpMessage: {
        type: String,
        default: ""
      },
      show: {
        type: Boolean,
        required: true,
        default: false
      }
    },

    methods: {
      onSubmitOtp() {
        if (this.checkForValidation()) {
          this.$emit("onSubmitOtp", { "otp": this.otp });
        }
      },

      checkForValidation() {
        if (!EzUtils.containsOnlyNumbers(this.otp)) {
          this.validationError = "Please enter valid OTP";
          return false;
        }

        this.validationError = "";
        return true;
      },

      onOTPUpdated(otp) {
        this.otp = otp;
        this.validationError = "";
      },

      resendOtp() {
        this.$emit("onResendOtp")
      },

      optSent() {
        this.countDowntime = new Date().getTime() + RESEND_OTP_TIME; //30 seconds
        this.countdownCompleted = false;
      },

      onCountdownCompleted() {
        this.countdownCompleted = true
      },

      countdownDetails(countdownData) {
        this.countdownRemainingSeconds = countdownData.second
      },
    },

    computed: {
      error() {
        return this.otpError || this.validationError;
      }
    }
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>

<style scoped>

  .otp-container {
    margin: 20px auto;
    position: relative;
    background: #F9F9F9;
    padding: 10px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
  }
</style>
